export function startInactivityTimeout(
  callback: (timeInactive: number) => void,
  timeout: number,
) {
  let timer: NodeJS.Timeout | null;
  let timeLastVisible: number | null;
  let hasInteracted = false;

  function clearTimer() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function resetTimer() {
    hasInteracted = true;
    clearTimer();
    timer = setTimeout(() => callback(timeout), timeout);
  }

  // Handle visibility change manually as timeouts are throttled differently on different browsers.
  function handleVisibilityChange() {
    if (document.visibilityState === "visible") {
      if (timeLastVisible !== null) {
        const timeSinceLastVisibleMs = Date.now() - timeLastVisible;
        if (timeSinceLastVisibleMs >= timeout) {
          callback(timeSinceLastVisibleMs);
        }
        timeLastVisible = null; // Reset the time since last visible
      }
      if (hasInteracted) resetTimer();
    } else {
      clearTimer();
      timeLastVisible = Date.now();
    }
  }

  window.addEventListener("visibilitychange", handleVisibilityChange);
  window.addEventListener("scroll", resetTimer, true); // true for capturing phase, so it works on scroll events

  const events = ["keydown", "mousemove", "mousedown", "touchstart", "click"];
  events.forEach((name) => {
    window.addEventListener(name, resetTimer);
  });

  timer = setTimeout(() => callback(timeout), timeout);

  return () => {
    clearTimer();
    window.removeEventListener("scroll", resetTimer, true);
    window.removeEventListener("visibilitychange", handleVisibilityChange);
    events.forEach((name) => {
      window.removeEventListener(name, resetTimer);
    });
  };
}
